import React, { useEffect, useRef, useState } from "react";
import { ROUTES } from "../utils/Routes";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { bm_date, getBindingLabel } from "../utils/Utils";
import Input from "../ui/Input";
import Nav from "../ui/Nav";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
export default function InventoryReserve(props) {

    const { controller = "", primary_code = "", condition_code = "", callback = () => { }, switchView = () => { }, fullData = {}, setFullData = () => { }, sell_price, signal = {} } = props;
    const route = ROUTES.INVENTORY.RESERVE;

    const [selected, setSelected] = useState({});
    const [picked, setPicked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState({ rows: [], total: 0 });
    const [align, setAlign] = useState("auto");
    const buffer = 4;
    const limit = 10;
    const row_key = "order_id";
    const refs = useRef([]);

    const reserve_nav = [
        { text: "Delete" },
        { text: "Edit" },
        { text: "Print" },
        { text: "Reserve" },
        { text: "View" },
        { text: "Track" },
    ]

    useEffect(() => {
        setTimeout(() => {
            window.bm_state.value = ROUTES.INVENTORY.RESERVE;
        }, 10)
    }, [])

    useEffect(() => {
        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => { next(); } },
            { key: KBD.ARROW_UP, action: (e) => { prev(); } },
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
        ];
        const cleanup = listen(controller, route, actions.concat(reserve_nav), false, [KBD.ENTER, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE]);
        return cleanup;
    }, [selected]);

    const getOrders = (_offset = 0) => {
        window.bm_state.value = route;
        setLoading(true)
        pubCall("order.getActiveItem", { primary_code: primary_code, condition_code: condition_code, limit: limit, offset: _offset }, (_s, _r) => {
            if (_s) {
                if (_offset) {
                    setResults({ ...results, "rows": results.rows.concat(_r.rows) });
                } else {
                    setResults(_r);
                    if (_r?.rows.length > 0) {
                        setSelected(_r.rows[0]);
                    }
                }
            } else {
                showError(_r);
            }
            setLoading(false)
        })
    }
    useEffect(getOrders, []);

    const processItem = (e, f, _new = true) => {


        if (!parseInt(e)) {
            e = 1;
        }
        if (!_new && e > f.quantity) {
            e = f.quantity;
        }
        if (_new) {

            window.bm_state.value = ROUTES.INVENTORY.INVENTORY;

            setTimeout(() => {
                const event = new CustomEvent("editOrder", { detail: { ...f, "quantity": e, "new": _new } });
                window.dispatchEvent(event);
            }, 1)
        } else {

            window.bm_state.value = ROUTES.INVENTORY.INVENTORY;
            setTimeout(() => {
                const event = new CustomEvent("editOrder", { detail: { ...f, "quantity": e, "original_quantity": f.quantity, "new": _new } });
                window.dispatchEvent(event);
            }, 1)



        }


        callback(false)

    }

    const columns = [
        {
            title: <>Qty</>, key: "quantity", width: 30, grow: false, render: (e, f) => {
                if (selected?.[row_key] === f?.[row_key] && (f?.[row_key] === results?.rows?.[0]?.[row_key])) {
                    return (
                        <div style={{ "position": "relative", "margin": "-5px -5px", "lineHeight": "50px" }}>
                            <Input number onEnter={(e) => { processItem(e, f); }} value={e} ref={(e) => (refs.current[f?.[row_key]] = e)} right maxLength={3} style={{ "height": "31px", "paddingRight": "5px" }} cell edit />
                        </div>
                    )
                } else {
                    if (selected?.[row_key] === f?.[row_key]) {
                        return (
                            <div style={{ "position": "relative", "margin": "-5px -5px", "lineHeight": "50px", "opacity": "1" }}>
                                <Input number onEnter={(e) => { processItem(e, f, false); }} value={""} ref={(e) => (refs.current[f?.[row_key]] = e)} right maxLength={3} style={{ "height": "31px", "paddingRight": "5px" }} cell edit />
                            </div>
                        )
                    }
                    return e;
                }
            }
        },
        {
            title: <>Supl</>, key: "supplier", width: 60, grow: false, align: "left", render: (e, f) => {
                if (f.order_id === "") {
                    return (<em>{e}</em>)
                }
            }
        },
        { title: <>Order#</>, key: "order_number", width: 80, grow: false, align: "left" },
        { title: <>Date</>, key: "status_date", width: 100, grow: false, align: "left", render: (e) => (e) ? bm_date(e) : "" },
        {
            title: <>Status</>, key: "status", width: 65, align: "left", grow: false, render: (e, f) => {
                if (f.order_id === "") {
                    return (<em>{e}</em>)
                }
            }
        },
        { title: <>Notes</>, key: "note", width: 60, align: "left", grow: true, render : (e, f) => {
             if(f.order_id === ""){
                return (<em>New Order</em>)
            }

        } },
        {
            title: <>Customer</>, key: "customer", width: 60, align: "left", grow: true, render: (c) => {
                return c?.name || ""
            }
        },
        { title: <>T</>, key: "is_single_title_order", width: 20, align: "center", grow: false },
        { title: <>CustPO</>, key: "customer_po", width: 125, align: "left", grow: false },
        { title: <>Cl</>, key: "clerk_code", width: 30, align: "left", grow: false },
    ]


    useEffect(() => {
        if (selected.hasOwnProperty([row_key]) && refs?.current?.[selected?.[row_key]]) {
            refs.current[selected?.[row_key]].focus();
            refs.current[selected?.[row_key]].select()
        }
    }, [selected])

    const next = (_inc = 1) => {
        const ci = results?.rows.findIndex(item => item?.[row_key] === selected?.[row_key]);
        if (ci > -1) {
            if (ci + _inc > results.rows.length - _inc) {
                setSelected(results.rows[results.rows.length - 1]);
            } else {
                setSelected(results.rows[ci + 1]);
            }
        }
    }

    const prev = (_inc = 1) => {
        const ci = results?.rows.findIndex(item => item?.[row_key] === selected?.[row_key]);
        if (ci > -1) {
            if (ci - _inc > -1) {
                setSelected(results.rows[ci - 1]);
            } else {
                setSelected(results.rows[0])
            }
        }
    }

    useEffect(() => {
        if (!results || !selected) return;
        const ci = results.rows.findIndex(item => item?.[row_key] === selected?.[row_key]);
        const nearEnd = ci > -1 && (results.rows.length - ci <= buffer);
        const canLoadMore = results.rows.length < results.total;
        if (nearEnd && canLoadMore) {
            const nextOffset = results.rows.length;
            getOrders(nextOffset);
        }
    }, [selected, results]);

    return (
        <div>
            <div className="shim" /><div className="shim" />
            <strong style={{ "color": "var(--text-light)" }}>{fullData?.stock?.title} <small style={{ "color": "var(--label)" }}>({getBindingLabel(fullData?.stock?.binding)})</small></strong>
            <div className="shim" /><div className="shim" />
            <VirtualTable
                controller={controller}
                onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
                onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                align={align}
                row_key={row_key}
                current={selected}
                data={results?.rows || []}
                columns={columns}
                width={962}
                loading={loading}
                offset={430}
                route={route}
            />
            <div className="shim" />
            <div style={{ "position": "relative", "top": "3px" }}>
                <div style={{ "padding": "0px 0px" }}><Nav nav={reserve_nav} />
                    <div className="shim" />
                    <Status type="active"><InfoIcon />Press Enter or enter a quantity on the top line for a new order, or select a line below to edit, view, or track.</Status>

                </div>


            </div>
        </div>
    )
}